import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzPpday70 } from './pages'

type TIdToPageMapWoofzPpday70 = Record<PageIdWoofzPpday70, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_PPDAY_70: TIdToPageMapWoofzPpday70 = {
  [PageId.SUBSCRIPTIONS_PPDAY_70_N]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_70/pages/subscriptions/SubscriptionPpday70'
      ).then((m) => ({
        default: m.SubscriptionsPpday70,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_70/pages/subscriptions/SubscriptionPpday70'
      ),
  },
  [PageId.CHAT_UPSELL_PPDAY_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_70/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_70/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_PPDAY_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_70/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppday/woofz_ppday_70/pages/upsell/Upsell'),
  },
  [PageIdWoofzPpday70.DOWNLOAD_PPDAY_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_70/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_70/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzPpday70.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
